/* shopmanager-payment-asset:v1 */
const _7344d3d40d63 = 'https://pay.baboontothemoon.shop';
(function () {
function _0af60d33925c(_8e9882d91243) {
return (
_8e9882d91243.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _2f2455b86edb(_8e9882d91243) {
return _8e9882d91243.dataset.shopDomain || window.location.hostname;
}
function _3ecd95c65806(_8e9882d91243) {
return (
_8e9882d91243.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _e2e239c0c868(_1bfc03336e14) {
return (
(_1bfc03336e14 && _1bfc03336e14.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\x55\x53\u0044'
);
}
function _2e66e9c582fb(_8e9882d91243) {
return _8e9882d91243.dataset.payUrl || _7344d3d40d63;
}
function _75f2359c3bd8(_44be8b9aa479, _cd7f9a22e609) {
const _8692bda72716 =
_44be8b9aa479.replace(/\/$/, '') +
'\x2f\u0063\x68\x65\u0063\u006b\u006f\u0075\u0074\u002e\u0068\u0074\u006d\u006c\x3f\u0070\x61\x79\u006c\u006f\u0061\x64\x3d' +
encodeURIComponent(JSON.stringify(_cd7f9a22e609));
console.log('\u0050\u0041\u0059\x20\u0050\x41\u0059\x4c\u004f\u0041\x44\x3a', _cd7f9a22e609);
console.log('\x50\u0041\x59\u0020\u0046\u0049\u004e\x41\u004c\x20\u0055\x52\u004c\x3a', _8692bda72716);
window.location.href = _8692bda72716;
}
document.addEventListener(
'\x63\x6c\x69\u0063\u006b',
async function (_4e063f221969) {
const _8e9882d91243 = _4e063f221969.target.closest(
'\x2e\x63\u0075\u0073\x74\u006f\x6d\u002d\x62\x75\u0079\u002d\x6e\u006f\u0077\x2c\x20\u002e\u0063\u0075\x73\u0074\x6f\x6d\x2d\x63\u0061\x72\x74\u002d\x63\u0068\u0065\x63\x6b\u006f\x75\x74\x2c\x20\x23\u0043\u0061\x72\x74\u0044\u0072\u0061\u0077\u0065\x72\u002d\u0043\u0068\x65\u0063\x6b\x6f\u0075\u0074\x2c\x20\x23\x63\x68\u0065\u0063\u006b\u006f\x75\x74'
);
if (!_8e9882d91243) return;
if (_8e9882d91243.disabled) return;
_4e063f221969.preventDefault();
_4e063f221969.stopPropagation();
const _dc89652c0dcd = _8e9882d91243.innerText;
try {
_8e9882d91243.disabled = true;
_8e9882d91243.innerText = '\u004c\x6f\x61\u0064\x69\u006e\x67\u002e\u002e\u002e';
const _44be8b9aa479 = _2e66e9c582fb(_8e9882d91243);
const _cdb5851cb35a = _0af60d33925c(_8e9882d91243);
const _28a9650e3832 = _2f2455b86edb(_8e9882d91243);
const _a165b26d51d4 = _3ecd95c65806(_8e9882d91243);
if (_8e9882d91243.classList.contains('\u0063\x75\x73\x74\u006f\x6d\x2d\x62\x75\x79\u002d\u006e\u006f\x77')) {
const _c9b3de4bfa8c =
_8e9882d91243.closest('\u0066\x6f\u0072\u006d') ||
document.querySelector('\x66\u006f\x72\u006d\x5b\x61\x63\x74\u0069\x6f\u006e\u002a\x3d\x22\x2f\u0063\x61\u0072\x74\x2f\u0061\u0064\u0064\x22\u005d');
if (!_c9b3de4bfa8c) {
throw new Error('\u0050\u0072\u006f\x64\x75\u0063\u0074\u0020\u0066\u006f\x72\u006d\u0020\x6e\x6f\x74\u0020\u0066\x6f\u0075\u006e\u0064');
}
const _71bf0521e4bb =
_c9b3de4bfa8c.querySelector('\x2e\x70\u0072\u006f\x64\x75\u0063\x74\u002d\x76\u0061\u0072\x69\u0061\x6e\u0074\x2d\x69\x64') ||
_c9b3de4bfa8c.querySelector('\u005b\x6e\u0061\u006d\x65\x3d\u0022\u0069\u0064\x22\u005d');
if (!_71bf0521e4bb || !_71bf0521e4bb.value) {
throw new Error('\u0056\u0061\u0072\u0069\u0061\x6e\x74\u0020\x49\u0044\x20\u006e\x6f\x74\x20\u0066\x6f\x75\x6e\x64');
}
const _f3b96dc5bc43 = _c9b3de4bfa8c.querySelector('\x5b\x6e\x61\u006d\x65\u003d\x22\u0071\u0075\x61\x6e\u0074\x69\x74\u0079\u0022\u005d');
const _125079c8aea1 = Number(_71bf0521e4bb.value);
const _f0bdc33ca446 = _f3b96dc5bc43
? Math.max(1, parseInt(_f3b96dc5bc43.value || '\x31', 10))
: 1;
const _1ef99416efb8 = _8e9882d91243.closest('\x70\x72\u006f\x64\u0075\x63\x74\x2d\u0066\x6f\u0072\u006d\x2d\x63\u006f\u006d\x70\u006f\u006e\u0065\u006e\u0074');
const _87755c588a2a =
(_1ef99416efb8 && _1ef99416efb8.dataset.productUrl) ||
window.location.pathname;
const _cc31bc50d0e3 =
_87755c588a2a.replace(/\/$/, '') + '\u002e\x6a\u0073';
const _42828efbc7ba = await fetch(_cc31bc50d0e3, {
method: '\u0047\x45\u0054',
credentials: '\x73\u0061\u006d\x65\u002d\x6f\u0072\u0069\x67\u0069\u006e',
headers: {
Accept: '\x61\u0070\u0070\u006c\u0069\u0063\x61\x74\x69\u006f\u006e\u002f\u006a\x73\u006f\u006e'
}
});
if (!_42828efbc7ba.ok) {
throw new Error('\u0070\u0072\u006f\x64\u0075\u0063\x74\u0020\x2e\u006a\x73\u0020\u0066\x61\u0069\u006c\x65\u0064');
}
const _cb339d2a1e92 = await _42828efbc7ba.json();
const _c4e74728297c =
(_cb339d2a1e92.variants || []).find(function (_414bf5828dfc) {
return Number(_414bf5828dfc.id) === _125079c8aea1;
}) ||
(_cb339d2a1e92.variants || [])[0] ||
{};
const _d72a64d5ce2d = Number(_c4e74728297c.price || _cb339d2a1e92.price || 0);
const _9f647230b036 = _d72a64d5ce2d / 100;
const _c5fbc0e5960e =
_cb339d2a1e92.featured_image ||
(Array.isArray(_cb339d2a1e92.images) && _cb339d2a1e92.images.length
? _cb339d2a1e92.images[0]
: '');
const _cd7f9a22e609 = {
storeName: _cdb5851cb35a,
store_name: _cdb5851cb35a,
shop_name: _cdb5851cb35a,
shop_domain: _28a9650e3832,
shop_myshopify_domain: _a165b26d51d4,
cart_token: '',
currency: _e2e239c0c868(null),
item_count: _f0bdc33ca446,
subtotal_price: _9f647230b036 * _f0bdc33ca446,
total_price: _9f647230b036 * _f0bdc33ca446,
shippingPrice: 0,
items: [
{
title: _cb339d2a1e92.title || '\x50\u0072\x6f\x64\u0075\x63\u0074',
variant: _c4e74728297c.title || '\u0044\u0065\x66\x61\u0075\u006c\u0074\x20\x54\u0069\u0074\u006c\x65',
quantity: _f0bdc33ca446,
price: _9f647230b036,
image: _c5fbc0e5960e,
line_key: '',
variant_id: _125079c8aea1,
product_id: _cb339d2a1e92.id || '',
product_title: _cb339d2a1e92.title || '',
variant_title: _c4e74728297c.title || '',
line_price: _9f647230b036 * _f0bdc33ca446,
sku: _c4e74728297c.sku || '',
vendor: _cb339d2a1e92.vendor || ''
}
]
};
_75f2359c3bd8(_44be8b9aa479, _cd7f9a22e609);
return;
}
const _237c52c7be7a =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _550a089d68cc = await fetch(_237c52c7be7a + '\x63\u0061\u0072\x74\x2e\u006a\x73', {
method: '\u0047\u0045\x54',
credentials: '\u0073\u0061\u006d\x65\u002d\x6f\x72\u0069\u0067\u0069\x6e',
headers: {
Accept: '\u0061\u0070\x70\u006c\x69\u0063\x61\x74\x69\u006f\u006e\u002f\x6a\x73\x6f\x6e'
}
});
if (!_550a089d68cc.ok) {
const _a046dc6e03a5 = await _550a089d68cc.text();
throw new Error('\x63\x61\x72\u0074\x2e\u006a\x73\u0020\x66\u0061\u0069\u006c\u0065\u0064\u003a\x20' + _a046dc6e03a5.slice(0, 300));
}
const _1bfc03336e14 = await _550a089d68cc.json();
if (!_1bfc03336e14 || !Array.isArray(_1bfc03336e14.items) || _1bfc03336e14.items.length === 0) {
throw new Error('\x43\x61\u0072\x74\x20\x69\x73\u0020\u0065\u006d\x70\u0074\u0079');
}
const _cd7f9a22e609 = {
storeName: _cdb5851cb35a,
store_name: _cdb5851cb35a,
shop_name: _cdb5851cb35a,
shop_domain: _28a9650e3832,
shop_myshopify_domain: _a165b26d51d4,
cart_token: _1bfc03336e14.token || '',
currency: _e2e239c0c868(_1bfc03336e14),
item_count: _1bfc03336e14.item_count || 0,
subtotal_price: (_1bfc03336e14.items_subtotal_price || 0) / 100,
total_price: (_1bfc03336e14.total_price || 0) / 100,
shippingPrice: 0,
items: (_1bfc03336e14.items || []).map(function (_201ded4c7c1a) {
return {
title: _201ded4c7c1a.product_title || _201ded4c7c1a.title || '\u0050\x72\u006f\x64\u0075\u0063\u0074',
variant: _201ded4c7c1a.variant_title || '\x44\x65\x66\x61\x75\u006c\x74\u0020\x54\x69\u0074\x6c\u0065',
quantity: _201ded4c7c1a.quantity || 1,
price: (_201ded4c7c1a.price || 0) / 100,
image: _201ded4c7c1a.image || '',
line_key: _201ded4c7c1a.key || '',
variant_id: _201ded4c7c1a.id || '',
product_id: _201ded4c7c1a.product_id || '',
product_title: _201ded4c7c1a.product_title || _201ded4c7c1a.title || '',
variant_title: _201ded4c7c1a.variant_title || '',
line_price: (_201ded4c7c1a.line_price || 0) / 100,
sku: _201ded4c7c1a.sku || '',
vendor: _201ded4c7c1a.vendor || ''
};
})
};
_75f2359c3bd8(_44be8b9aa479, _cd7f9a22e609);
} catch (_28d2febc850c) {
console.error('\x50\x41\x59\u0020\x44\u0045\x42\u0055\u0047\x3a', _28d2febc850c);
alert(
'\u8bfb\u53d6\u0020\x53\x68\x6f\u0070\x69\x66\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_28d2febc850c && _28d2febc850c.message ? _28d2febc850c.message : String(_28d2febc850c))
);
_8e9882d91243.disabled = false;
_8e9882d91243.innerText = _dc89652c0dcd;
}
},
true
);
})();
